import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpInterceptorFn
} from '@angular/common/http';
import { inject } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { Observable } from 'rxjs';
import { ePayService } from '../Service/ePayService';

export const BaseUrlInterceptor: HttpInterceptorFn =
  (request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {

    const platformLocation = inject(PlatformLocation);
    const epayService = inject(ePayService);

    console.log('BaseUrlInterceptor is active:', request.url);

    if (!request.url.startsWith('http')) {
      let baseUrl = platformLocation.getBaseHrefFromDOM() + request.url;
      baseUrl = baseUrl.replace('//', '/');

      request = request.clone({ url: baseUrl });

      if (epayService.sessionId) {
        request = request.clone({
          headers: request.headers.set('Authorization', epayService.sessionId),
        });
      }
    }

    return next(request);
  };


/*
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { PlatformLocation } from "@angular/common";
import { ePayService } from '../Service/ePayService';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
  constructor(private platformLocation: PlatformLocation, private route: Router, private ePayService: ePayService) {

  }

  //Add auth header
  addAuthHeader(request: any) {
    if (this.ePayService.sessionId) {
      const authHeader = this.ePayService.sessionId;
      console.log('Authorization', authHeader);
      if (authHeader) {
        // Clone the request to add the authentication header.
        return request.clone({
          headers: request.headers.append('Authorization', authHeader),
        });
      }
      console.info('AuthHeader', authHeader);
    }
    return request;
  }

  //rewrite the url
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log('BaseUrlInterceptor is active:', request.url);
    if (!(request.url.includes("http://") || request.url.includes("https://"))) {
      var baseUrl = this.platformLocation.getBaseHrefFromDOM() + request.url;
      baseUrl = baseUrl.replace('//', '/');
      console.info('new url', baseUrl);
      request = request.clone({ url: baseUrl });

      request = this.addAuthHeader(request);
    }
    return next.handle(request);
  }
}
*/
